module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LQ150X1LX95-2-20-14.91d9090c.pdf";